<template>
  <tr>
    <td>
      <input
      type="checkbox"
      v-model="selected"
      @click="addInvoice(cData)"
      >
    </td>
    <td>{{ cData.customer_name }}</td>
    <td>{{ cData.email }}</td>
    <td>{{ cData.order_date | filterDate }}</td>
    <td>{{ cData.invoice || 'n/a' }}</td>
    <td>{{ cData.date | filterDate }}</td>
    <td>{{ formatMoney(cData.amount) }}</td>
    <template v-if="!loaderButton">
      <td
        @click="openPdf(cData.json)"
      >
        <img
          :src="require('@/assets/icons/pdf.svg')" alt="pdf preview"
        />
      </td>
    </template>
    <template v-else>
    <td>
      <LoaderPDF />
    </td>
    </template>
  </tr>
</template>

<script>
import { downloadBlob } from '../../utils/downloadBlob';
import LoaderPDF from '../Loader/LoaderPDF.vue';

export default {
  name: 'line-table',
  data() {
    return {
      loaderButton: false,
      selected: false,
      pdf: '',
    };
  },
  props: {
    data: [Object, Array],
  },
  components: {
    LoaderPDF,
  },
  watch: {
    '$store.getters.value': function selected() {
      this.selected = false;
    },
  },
  computed: {
    cData() {
      if (this.data) {
        return this.data;
      }
      return '';
    },
  },
  methods: {
    formatMoney(value) {
      return value.toLocaleString('en-CA', { style: 'currency', currency: 'USD' });
    },
    addInvoice(value) {
      this.selected = !this.selected;
      const bool = this.selected;
      this.$emit('addInvoice', { value, bool });
    },

    async openPdf(json) {
      const value = JSON.parse([json]);
      try {
        this.loaderButton = true;
        const { data: response } = await this.$http.post('/v1/pdf-preview', { value }, { responseType: 'blob' });
        downloadBlob(response);
        this.loaderButton = false;
      } catch (error) {
        console.error(error);
        this.loaderButton = false;
      }
    },
  },
};
</script>
<style scoped lang="scss">
tr {
  width: 100%;
}
td {
  display: flex;
  /* justify-content: center; */
  align-items: center;
  text-align: left;
  width: 200px;
  min-height: 65px;
  font-weight: 500;
  font-size: 13.8355px;
  margin: 0 2px;
  color: $dataTable;
  @media(min-width: 1440px) {
    width: 100%!important;
  }
  &:first-child {
    width: 140px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &:nth-child(2) {
    width: 150px;
  }
  &:nth-child(3) {
    width: 250px;
  }
  &:nth-child(4) {
    width: 120px;
  }
  &:nth-child(5) {
    width: 150px;
  }
  &:nth-child(6) {
    width: 180px;
  }
  &:nth-child(7) {
    width: 100px;
  }
  &:nth-child(8) {
    position: relative;
    width: 100px;
    padding-left: 35px;
    cursor: pointer;
  }
}
tr {
  display: flex;
  flex-direction: row;
}
.line-table {
  display: flex;
  min-width: 1262px;
  justify-content: space-between;
  height: 65px;
  &:nth-child(odd) {
    background-color: $backgroundLineTable;
  }
  h2 {
    img {
      width: 25px;
      height: 25px;
      margin-right: 6px;
    }
    font-weight: 500;
    font-size: 13.8355px;
    color: $dataTable;
    display: flex;
    align-items: center;
    margin-right: 45px;
    white-space: nowrap;
    text-align: left;
    @media (min-width: 1440px) {
      margin-right: 0px !important;
    }
    img {
      cursor: pointer;
    }
    @media (min-width: 1440px) {
      &:nth-child(1) {
        white-space: normal;
        padding-left: 29px;
        min-width: 10%;
        max-width: 10%;
      }
      &:nth-child(2) {
        min-width: 10%;
      }
      &:nth-child(3) {
        min-width: 10%;
      }
      &:nth-child(4) {
        min-width: 10%;
      }
      &:nth-child(5) {
        min-width: 10%;
      }
      &:nth-child(6) {
        min-width: 10%;
      }
      &:nth-child(7) {
        min-width: 10%;
      }
    }
  }
}
</style>
